import { Component, OnInit } from '@angular/core';
import { Navigator } from 'src/app/components/menu/navigator';
import { ConfigService } from 'src/app/services/config/config.service';
import { TimeService } from 'src/app/services/time-service/time.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';

@Component({
  selector: 'app-popover-session-stats',
  templateUrl: './popover-session-stats.component.html',
  styleUrls: ['./popover-session-stats.component.scss'],
})
export class PopoverSessionStatsComponent implements OnInit {
  sessionStatsData;
  timeOnline;
  showNetWin: boolean;
  public sessionStatsOptions;
  currentTime:any;
  public PIPE_DATE_FORMAT = !!this.config.getConfig().FEATURE_TIME_FORMAT_TO
  ? this.config.getConfig().FEATURE_TIME_FORMAT_TO
  : "hh:mm a"; //MM-dd-yyyy, hh:mm a' Use this for Full date
  constructor(
    private navigator:Navigator,
    private userSession: UserSessionService,
    private config:ConfigService,
    private timeService:TimeService
  ) { 
    this.sessionStatsData = this.navigator.activePopovers[this.navigator.activePopovers.length-1].componentProps.data.message;
    this.showNetWin = this.config.getConfig().FEATURE_SHOW_NET_WIN_SESSION_STATS === '1' ? true : false;
  }

  ngOnInit() {

    if(this.sessionStatsData.parametersMap) {
      let minutesReceived = this.sessionStatsData.parametersMap.time;
        
      let hours = Math.trunc(minutesReceived/60);
      let minutes = minutesReceived % 60;

      this.timeOnline = hours > 0 ? hours + " hour(s) " + minutes + " minute(s)." : minutes + " minute(s)";
    }
    this.timeService.getServerTime().then((serverTime:any) => {
			if (serverTime.result == 1) {
        this.currentTime = serverTime.payload.full;
			}

		});
    setTimeout(() => {
      this.closePopover();
    }, 20000);
  }

  closePopover() {
    //this.navigator.dismissAll();
    this.navigator.activePopovers[this.navigator.activePopovers.length-1].dismiss();
  }
}